import {
  copy,
  replace,
  hash,
  match,
  combine,
  serialize,
  DECLARATION,
  KEYFRAMES,
  RULESET,
  MS,
  MOZ,
  WEBKIT
} from 'stylis'

// Customized prefixer
// https://github.com/thysultan/stylis.js/blob/master/src/Prefixer.js
export function prefix(value: string, length: number): string {
  switch (hash(value, length)) {
    case 5572: // text-decoration
    case 6356: // filter
    case 5844: // clip-path
    case 3191: // backface-visibility
    case 3005: // box-decoration-break
    case 6391: // mask
    case 5879: // mask-image
    case 5623: // mask-(mode|clip|size)
    case 6135: // mask-(repeat|origin)
    case 4599: // mask-position
    case 4855: // mask-composite
    case 4215: // background-clip
      return WEBKIT + value + value
    case 5349: // appearance
    case 4246: // user-select
    case 6968: // hyphens
    case 2756: // text-size-adjust
      return WEBKIT + value + MOZ + value + MS + value + value
  }

  return value
}

type Element = {
  value: string
  type: DECLARATION | KEYFRAMES | RULESET
  props: string[]
  length: number
  return: string
}

export interface ProcessEnv {
  env: {
    [key: string]: string | undefined
  }
}

declare let process: ProcessEnv

export function prefixer(
  element: Element,
  index: number,
  children: Record<string, unknown>[],
  callback: () => void
): void {
  if (!element.return)
    switch (element.type) {
      case DECLARATION:
        element.return = prefix(element.value, element.length)
        break
      case KEYFRAMES:
        return serialize(
          [copy(replace(element.value, '@', '@' + WEBKIT), element, '')],
          callback
        )
      case RULESET:
        if (element.length)
          return combine(element.props, function (value) {
            if (process.env.NODE_ENV === 'development') {
              return ''
            }
            switch (match(value, /(::plac\w+|:read-\w+)/)) {
              // :read-(only|write)
              case ':read-only':
              case ':read-write':
                return serialize(
                  [
                    copy(
                      replace(value, /:(read-\w+)/, ':' + MOZ + '$1'),
                      element,
                      ''
                    )
                  ],
                  callback
                )
            }

            return ''
          })
    }
}
